import * as THREE from "three";
import { Context } from "../core/context";
import { DBEntity, DbLine, DbMesh } from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  DrawDoorOrWindowAcceptParams,
  DrawDoorOrWindowReturnData,
  ElevationAnnotationModifyReturnData,
} from "@/core/Parameters";
import { WasmUtil } from "@/utils/WasmUtil";

class DrawDoorOrWindowModify implements IModifyOperation {
  private m_context: Context;
  private m_locationObject: THREE.Line;
  private m_auxLine: THREE.Line | undefined;
  private m_returnData: DrawDoorOrWindowReturnData = {
    extendId: undefined,
    basePoint: undefined,
    dirPoint: undefined,
    thick: 0.4,
  };
  private m_TextLabel: ULabel;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_points: THREE.Vector3[] = [];
  private m_scale: number = 1;
  private m_tempObjectGroup: THREE.Group = new THREE.Group();
  private m_tempObject: THREE.LineSegments | undefined;
  private m_callbackUnderway: (point: THREE.Vector3) => void;
  private m_TextLabelLocation: THREE.Vector3 = new THREE.Vector3();
  private m_acceptParams: DrawDoorOrWindowAcceptParams;
  private m_tempObjectBasePoints: THREE.Vector3[] = [];
  private m_curSelect: DbLine | undefined = undefined;
  private m_allWallData: DbLine[] = [];
  private m_maxDistance = 0.35;
  private m_tempDirLine: THREE.LineSegments | undefined;
  private m_tempDirLineBasePoints: THREE.Vector3[] = [];
  private m_dirVector: THREE.Vector3 | undefined = undefined;

  constructor(context: Context, params: DrawDoorOrWindowAcceptParams) {
    this.m_context = context;
    this.m_acceptParams = params;
    this.m_callbackUnderway = params.callbackUnderway;
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_context.SceneManager.AuxModel.add(this.m_tempObjectGroup);
    this.createTempObject();
    this.createTempDirLine();
    let selectAll: (DbLine | DbMesh)[] = [];
    selectAll.push(
      ...this.m_context.ModelManager.PassLayerNameGetData(
        this.m_acceptParams.wallLayerName
      )
    );
    selectAll.forEach((item) => {
      if (item instanceof DbLine) {
        this.m_allWallData.push(item);
      }
    });
    // console.log(selectAll);
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point.clone();
    this.m_locationObject.position.copy(this.m_curPoint);
    this.m_TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 35;
    this.m_TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
    this.m_TextLabel.SetVaule(
      "请点取墙中心线,按ECS键将退出操作",
      this.m_TextLabelLocation,
      new THREE.Vector3(1, 0, 0)
    );
    if (this.m_points.length == 1) {
      this.m_TextLabel.SetVaule(
        "请选取方向,按ECS键将退出操作",
        this.m_TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
      this.m_auxLine?.geometry.setFromPoints([
        this.m_points[0],
        this.m_curPoint,
      ]);
      this.m_auxLine?.computeLineDistances();
      if (this.m_tempDirLine) {
        this.updatedTempDirLineBasePoints(this.m_acceptParams.width, true);
        this.m_tempDirLine.geometry.setFromPoints(this.m_tempDirLineBasePoints);
        this.m_tempDirLine.position.copy(this.m_points[0]);
        this.updateCurTempObject(true);
      }
    }
    if (this.m_points.length == 2) {
      this.m_TextLabel.SetVaule(
        "请确定操作,按ECS键将退出操作",
        this.m_TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    }
    if (!this.m_points.length && this.m_tempObject && this.m_tempDirLine) {
      this.updateTempObjectBasePoints(this.m_acceptParams.width);
      this.updatedTempDirLineBasePoints(this.m_acceptParams.width);
      this.m_tempObject.geometry.setFromPoints(this.m_tempObjectBasePoints);
      this.m_tempObject.position.copy(this.m_curPoint);
      this.m_tempDirLine.geometry.setFromPoints(this.m_tempDirLineBasePoints);
      this.m_tempDirLine.position.copy(this.m_curPoint);
      let { obejct } = point;
      if (obejct?.length) {
        let obj = obejct[0];
        if (obj instanceof DbLine) {
          this.m_curSelect = obj;
          let layerName = this.m_context.ModelManager.GetLayerById(
            obj.layerId
          )?.Name;
          if (
            layerName &&
            (this.m_acceptParams.wallCenterLayerName.includes(layerName) ||
              this.m_acceptParams.wallLayerName.includes(layerName))
          ) {
            if (
              layerName &&
              this.m_acceptParams.wallCenterLayerName.includes(layerName)
            ) {
              this.computerThickness(point);
            }
            this.updateCurTempObject(true);
          } else {
            this.updateCurTempObject();
          }
        }
      }
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    let { obejct } = point;
    if (this.m_points.length == 1) {
      this.m_returnData.dirPoint = point.point.clone();
      this.m_points.push(point.point.clone());
      this.m_callbackUnderway(point.point);
      this.m_TextLabel.SetVaule(
        "请确定操作,按ECS键将退出操作",
        this.m_TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
      return;
    }
    if (obejct?.length) {
      let obj = obejct[0];
      if (obj instanceof DbLine) {
        let layerName = this.m_context.ModelManager.GetLayerById(
          obj.layerId
        )?.Name;
        if (
          layerName &&
          this.m_acceptParams.wallCenterLayerName.includes(layerName)
        ) {
          this.m_points.push(point.point.clone());
          this.m_curSelect = obj;
          this.m_returnData.extendId = obj.extend_id;
          this.m_returnData.basePoint = point.point.clone();
          if (this.m_points.length == 1) {
            this.m_TextLabel.SetVaule(
              "请选取方向,按ECS键将退出操作",
              this.m_TextLabelLocation,
              new THREE.Vector3(1, 0, 0)
            );
            this.m_auxLine = this.m_context.ToolsManager.CreatedAuxLine();
          }
        }
      }
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (e.key == "Escape") {
      this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    if (operate == ModifyOperateState.complete) {
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private createTempObject() {
    this.updateTempObjectBasePoints(this.m_acceptParams.width);
    let geo = new THREE.BufferGeometry().setFromPoints(
      this.m_tempObjectBasePoints
    );
    let material = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let tempObject = new THREE.LineSegments(geo, material);
    this.m_tempObject = tempObject;
    this.m_tempObjectGroup.add(tempObject);
  }

  private updateCurTempObject(isFit: boolean = false) {
    if (!this.m_tempObject || !this.m_tempDirLine) return;
    if (isFit && this.m_curSelect) {
      this.m_tempObject.geometry.setFromPoints(this.m_tempObjectBasePoints);
      this.m_tempDirLine.geometry.setFromPoints(this.m_tempDirLineBasePoints);
      let { points } = this.m_curSelect;
      let startP = new THREE.Vector3(points[0], points[1], points[2]);
      let endP = new THREE.Vector3(points[3], points[4], points[5]);
      let vectorNormal = endP.clone().sub(startP).normalize();
      let xAxis = new THREE.Vector3(1, 0, 0);
      let angle = vectorNormal.angleTo(xAxis);
      if (vectorNormal.clone().cross(xAxis).z > 0) {
        angle = -angle;
      }
      if (Math.abs(angle - Math.PI) < 0.01) {
        angle = 0;
      }
      this.m_tempObject.geometry.rotateZ(angle);
      this.m_tempDirLine.geometry.rotateZ(angle);
    }
  }
  private updateTempObjectBasePoints(
    width: number,
    thickness1: number = 0.1,
    thickness2: number = 0.1
  ) {
    this.m_tempObjectBasePoints = [
      new THREE.Vector3(-width / 2, thickness1, 0),
      new THREE.Vector3(width / 2, thickness1, 0),
      new THREE.Vector3(width / 2, thickness1, 0),
      new THREE.Vector3(width / 2, -thickness2, 0),
      new THREE.Vector3(width / 2, -thickness2, 0),
      new THREE.Vector3(-width / 2, -thickness2, 0),
      new THREE.Vector3(-width / 2, -thickness2, 0),
      new THREE.Vector3(-width / 2, thickness1, 0),
    ];
  }
  private computerThickness(p: DrawOperationMovePointParams) {
    let points = Array.from(this.m_curSelect!.points);
    let curSelectStartP = new THREE.Vector3(points[0], points[1], points[2]);
    let curSelectEndP = new THREE.Vector3(points[3], points[4], points[5]);
    let startPVectorNormal = new THREE.Vector3()
      .subVectors(curSelectStartP, p.point)
      .normalize();
    let endPVectorNormal = new THREE.Vector3()
      .subVectors(curSelectEndP, p.point)
      .normalize();
    let startPVectorNormalDir1 = startPVectorNormal
      .clone()
      .applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 2)
      .setLength(this.m_maxDistance);
    let dirLine1EndP = new THREE.Vector3().addVectors(
      p.point,
      startPVectorNormalDir1
    );
    let dirLine1 = {
      points: [
        p.point.x,
        p.point.y,
        p.point.z,
        dirLine1EndP.x,
        dirLine1EndP.y,
        dirLine1EndP.z,
      ],
    };
    let startDirCrossPoints = this.getWallDataCrossPoint(
      dirLine1 as unknown as DbLine
    );
    let endPVectorNormalDir1 = endPVectorNormal
      .clone()
      .applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 2)
      .setLength(this.m_maxDistance);
    let dirLine2EndP = new THREE.Vector3().addVectors(
      p.point,
      endPVectorNormalDir1
    );
    let dirLine2 = {
      points: [
        p.point.x,
        p.point.y,
        p.point.z,
        dirLine2EndP.x,
        dirLine2EndP.y,
        dirLine2EndP.z,
      ],
    };
    let endDirCrossPoints = this.getWallDataCrossPoint(
      dirLine2 as unknown as DbLine
    );
    let startVDis = undefined;
    let endVDis = undefined;

    if (startDirCrossPoints.length) {
      let filterData: number[] = [];
      startDirCrossPoints.forEach((item) => {
        if (item.distanceTo(p.point) > 0.01) {
          filterData.push(item.distanceTo(p.point));
        }
      });
      if (filterData && filterData.length) {
        startVDis = Math.min(...filterData);
      }
    }
    if (endDirCrossPoints.length) {
      let filterData: number[] = [];
      endDirCrossPoints.forEach((item) => {
        if (item.distanceTo(p.point) > 0.01) {
          filterData.push(item.distanceTo(p.point));
        }
      });
      if (filterData && filterData.length) {
        endVDis = Math.min(...filterData);
      }
    }
    this.m_returnData.thick = 0.4;
    if (startVDis && endVDis) {
      this.updateTempObjectBasePoints(
        this.m_acceptParams.width,
        startVDis,
        endVDis
      );
      this.m_returnData.thick = startVDis + endVDis;
    }
  }
  private getWallDataCrossPoint(dbLine: DbLine) {
    let crossPoints = [];
    for (let i = 0; i < this.m_allWallData.length; i++) {
      const wallData = this.m_allWallData[i];
      let crossPoint = WasmUtil.IntersectPoints(
        this.m_context,
        dbLine,
        wallData,
        this.m_context.SelectionManager.Scale
      );
      if (crossPoint) {
        crossPoints.push(...crossPoint);
      }
    }
    return crossPoints;
  }

  private createTempDirLine() {
    this.updatedTempDirLineBasePoints(this.m_acceptParams.width);
    let geo = new THREE.BufferGeometry().setFromPoints(
      this.m_tempDirLineBasePoints
    );
    let material = new THREE.LineBasicMaterial({ color: CommonColor.White });
    let tempObject = new THREE.LineSegments(geo, material);
    this.m_tempDirLine = tempObject;
    this.m_tempObjectGroup.add(tempObject);
  }

  private updatedTempDirLineBasePoints(
    width: number,
    isChangerDir: boolean = false
  ) {
    this.m_tempDirLineBasePoints = [
      new THREE.Vector3(-width / 4, 0, 0),
      new THREE.Vector3(width / 4, 0, 0),
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(0, this.m_maxDistance, 0),
    ];
    if (isChangerDir && this.m_curSelect) {
      let { points } = this.m_curSelect;
      let startP = new THREE.Vector3(points[0], points[1], points[2]);
      let endP = new THREE.Vector3(points[3], points[4], points[5]);
      let vectorNormal = endP.clone().sub(startP).normalize();
      this.m_dirVector = this.m_curPoint.clone().sub(this.m_points[0]);
      let cross = this.m_dirVector.clone().normalize().cross(vectorNormal).z;
      if (cross > 0) {
        this.m_tempDirLineBasePoints[3] = new THREE.Vector3(
          0,
          -this.m_maxDistance,
          0
        );
      }
    }
  }

  private clear() {
    this.m_context.ToolsManager.GroupClear(this.m_tempObjectGroup);
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_auxLine!,
    ]);
    this.m_TextLabel?.dispose();
  }
}

export { DrawDoorOrWindowModify };
